<div class="ms-3 me-3">
  <form [formGroup]="form" *ngIf="form">
    <div *ngFor="let renderable of renderables; trackBy: trackBySubrenderables" class="form-row">
      <app-df-renderable [parentCardGroup]="parentCardGroup" [renderable]="renderable" [form]="form"></app-df-renderable>
    </div>
  </form>
</div>
